<template>
  <v-card elevation="0" :loading="loading">
    <v-card-text>
      <v-data-table :headers="table.headers" :items="deals" item-key="name" class="elevation-1" :search="table.search">
        <template #item.task="{ item }">
          <a :href="`https://app.hubspot.com/contacts/6239229/deal/${item.node.hubspotDealId}`" target="_blank"
            >{{ item.node.name }}
          </a>
        </template>
        <template #item.assignedTo="{ item }">
          <span v-if="item.node.owner"> {{ item.node.owner.firstName }} {{ item.node.owner.lastName }} </span>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { DEALS_QUERY } from "@/graphql/queries/user";

export default {
  name: "ClientDeals",
  props: ["userId"],
  data() {
    return {
      taskEvents: [],
      table: {
        search: "",
        headers: [
          { text: "Task", value: "task", sortable: true },
          { text: "Pipeline stage", value: "node.pipelineStage", sortable: true },
          { text: "Closed", value: "node.closed", sortable: true },
          { text: "Opportunity", value: "node.opportunity", sortable: true },
          { text: "Assigned to", value: "assignedTo" },
          { text: "Closed At", value: "node.closeDate", sortable: true },
        ],
      },
    };
  },
  methods: {},
  apollo: {
    deals: {
      query: DEALS_QUERY,
      variables() {
        let encoded_json_payload = btoa("UserNode:" + this.userId);
        return {
          userId: encoded_json_payload,
        };
      },
      fetchPolicy: "cache-and-network",
      update(data) {
        return data.deals.edges;
      },
    },
  },
};
</script>
